import { render } from "./AddVatTuItems.vue?vue&type=template&id=06491264&ts=true"
import script from "./AddVatTuItems.vue?vue&type=script&lang=ts"
export * from "./AddVatTuItems.vue?vue&type=script&lang=ts"

import "./AddVatTuItems.vue?vue&type=style&index=0&id=06491264&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__